module.exports = __webpack_public_path__ + "img/logo_2.5528610b.png";